import angular from 'angular';
import ngRoute from 'angular-route';
import routes from './reports.routes';
import generatedReports from './generatedReports';
import myReports from './myReports';
import archivedReports from './archivedReports';
import scheduledReports from './scheduledReports';
import packageReports from './packageReports';


export default angular.module('app.components.reports', [
  ngRoute,
  generatedReports,
  myReports,
  archivedReports,
  scheduledReports,
  packageReports
])
  .config(routes)
  .name;

console.log('app.components.reports created');
